module.exports = __webpack_public_path__ + "img/20191212171821692.b195b159.jpg";